// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3NWiA","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__wuXMi","gfeWrapper":"CalendarEvent_gfeWrapper__pbLjA"};